var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"sam-tag",class:{
    'mr-1': _vm.spaceRight, 
    'alert-tag': _vm.alert, 
    'tableItem': _vm.tableItem, 
    'active-tag': _vm.active,
    'warning-tag': _vm.warning
  }},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }